<template>
  <v-row>
    <v-col v-if="showAlert" cols="12" sm="12">
      <v-alert type="info">
        {{ infoText }}
      </v-alert>
    </v-col>
    <v-col cols="12" sm="6">
      <h5 v-if="renderComponent" class="display-1 success--text">Total Incl VAT: £{{ totalCost }}</h5>
      <v-text-field :disabled="booking.parentBookingId" prefix="£" class="mt-2" label="Booking Deposit"
                    v-model.number="totalToCharge" color="primary"/>
      <v-text-field :disabled="booking.parentBookingId" v-if="booking._id" prefix="£" class="mt-2"
                    label="Additional Charge" v-model.number="additionalCharge" color="primary"/>
      <v-select :disabled="booking.parentBookingId" label="Payment Method" :items="paymentMethods"
                v-model="booking.paymentMethod"/>
      <v-text-field :disabled="booking.parentBookingId" v-if="booking.paymentMethod === 'Other'"
                    label="Describe Payment Method" v-model.number="booking.paymentOtherDesc" color="primary"/>
      <div v-if="booking.paymentMethod === 'Card'">
        <!--                <v-stripe-card v-model="token" api-key="pk_test_IGpTtabJTh2vZbYfSKQJpWtz" ref="stripeCard"></v-stripe-card>-->
        <v-checkbox v-if="savedCard && savedCard.data[0] && savedCard.data[0].card" :label="`Use saved card ending: ${savedCard.data[0].card.last4}`" v-model="useSavedCard"></v-checkbox>
<!--        <v-stripe-card v-if="!useSavedCard" :disabled="booking.parentBookingId" v-model="token" api-key="pk_test_IGpTtabJTh2vZbYfSKQJpWtz"-->
<!--                       ref="stripeCard"></v-stripe-card>-->
        <v-stripe-card v-if="!useSavedCard" :disabled="booking.parentBookingId" v-model="token" api-key="pk_live_4QmR9EUVQedmZMn2nTW8VhUz" ref="stripeCard"></v-stripe-card>
        <v-layout>
          <v-spacer/>
          <v-btn @click="addCard = false" text color="info">Cancel</v-btn>
          <v-btn :loading="addingCard" :disabled="addingCard" @click="addCardIntent" color="info">Take Payment</v-btn>
        </v-layout>
      </div>
      <div>
        <v-checkbox label="Collect cash from customer for remaining payment" v-model="booking.isPayingCash" />
      </div>
    </v-col>
    <v-col cols="12" sm="6">
      <v-textarea :disabled="booking.isApproved" label="Notes" v-model="booking.notes"></v-textarea>
      <v-textarea :disabled="booking.isApproved" label="Upsell Opportunities"
                  v-model="booking.upsellOptions"></v-textarea>
      <v-select :disabled="booking.parentBookingId || booking.isApproved" label="Booking Made By" :items="agents"
                v-model="booking.bookingMadeBy"/>
    </v-col>
  </v-row>
</template>

<script>
import {PaymentsHttp} from "@/http/PaymentsHttp";
import {mapMutations} from 'vuex';
import EventBus from "../../../EventBus";

export default {
  name: "PaymentDetails",
  props: {
    booking: Object
  },
  data() {
    return {
      addingCard: false,
      token: null,
      paymentMethods: [
        'Card',
        'Cash',
        'Cheque',
        'Gift Voucher',
        'BACS',
        'Other'
      ],
      agents: [
        'Tristan',
        'Jamie',
          'Matt',
          'Callum',
        'Dan',
          'Kelly',
        'Other',
          "Website"
      ],
      showAlert: false,
      infoText: '',
      additionalCharge: 0,
      totalToCharge: 0,
      renderComponent: true,
      totalCost: 0,
      savedCard: null,
      useSavedCard: false
    }
  },
  watch: {
    totalToCharge(newVal) {
      EventBus.$emit('price-updated-manually', newVal);
    },
    "booking._id"() {
      this.totalToCharge = Number(this.booking.totalCharged);
    },
    booking: {
      async handler(newVal) {
        // eslint-disable-next-line no-console
        console.log(newVal);
        if (newVal.paymentMethod && newVal.paymentMethod === "Card" && newVal.customer.stripeId) {
          this.savedCard = await PaymentsHttp.getCustomer(newVal.customer.stripeId).then(result => result.data);
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    EventBus.$on('clear-payment', () => {
      this.infoText = '';
      this.showAlert = false;
      this.totalToCharge = 0;
    });

    EventBus.$on('price-change', (price) => {
      const p = price;
      const vat = p * 0.20;
      let total = p + vat;
      if (isNaN(total)) {
        this.totalCost = 0;
      } else {
        try {
          this.totalCost = total.toFixed(2);
        } catch (e) {
          const vat = Number(this.booking.price) * 0.20;
          this.totalCost = Number(this.booking.price) + vat;
        }
      }

      this.forceRerender();
    });

    if (this.booking._id) {
      this.totalToCharge = this.booking.totalCharged;
    }
  },
  methods: {
    ...mapMutations("app", ["setToast"]),
    // updatePrice() {
    //     this.booking.totalCharged = this.totalToCharge;
    //     EventBus.$emit('price-updated-manually', this.totalToCharge);
    // },
    forceRerender() {
      this.renderComponent = false;
      this.$nextTick(() => {
        this.renderComponent = true;
      });
    },
    async addCardIntent() {
      let charge = Math.ceil(this.totalToCharge * 100);
      if (this.booking._id && this.additionalCharge > 0) {
        charge = Math.ceil(this.additionalCharge * 100);
      }
      // eslint-disable-next-line no-console
      console.log(charge);

      if (this.useSavedCard) {
        try {
          this.addingCard = true;
          const transaction = await PaymentsHttp.createPaymentOffline(charge, this.booking.customer.stripeId).then(result => result.data);
          if (this.booking.paymentRef && this.booking.paymentRef.length > 0) {
            this.booking.paymentRef.push(transaction.id)
            this.$emit('update-refs', transaction.id);
          } else {
            this.booking.paymentRef = [transaction.id];
          }
          this.booking.totalCharged = charge / 100 + Number(this.additionalCharge);
          const newTotal = charge / 100 + Number(this.additionalCharge);
          EventBus.$emit('price-updated-manually', newTotal);
          this.setToast({color: 'success', text: 'Payment Taken Successfully. DO NOT CLOSE THE WINDOW', show: true});
          this.showAlert = true;
          this.infoText = 'Payment Taken - You can now save the booking';
        } catch (err) {
          if (err.response) {
            this.setToast({color: 'error', text: err.response.data.error, show: true})
          } else {
            this.setToast({color: 'error', text: err.message, show: true})
          }
        } finally {
          this.addingCard = false;
          this.$refs.stripeCard.clearableCallback();
        }
      } else {
        try {
          this.addingCard = true;
          const paymentMethod = await this.$refs.stripeCard.stripe.createPaymentMethod({
            type: 'card',
            card: this.$refs.stripeCard.card
          }).then((method) => method);
          if (!this.booking.customer.stripeId) {
            // We need to create a stripe customer
            this.booking.customer.stripeId = await PaymentsHttp.createCustomer(this.booking.customer).then(result => result.data);
          }
          const transaction = await PaymentsHttp.createPayment(paymentMethod.paymentMethod.id, charge, this.booking.customer.email, this.booking.customer.stripeId).then(result => result.data);
          if (this.booking.paymentRef && this.booking.paymentRef.length > 0) {
            this.booking.paymentRef.push(transaction.id)
            this.$emit('update-refs', transaction.id);
          } else {
            this.booking.paymentRef = [transaction.id];
          }
          this.booking.totalCharged = charge / 100 + Number(this.additionalCharge);
          const newTotal = charge / 100 + Number(this.additionalCharge);
          EventBus.$emit('price-updated-manually', newTotal);
          this.setToast({color: 'success', text: 'Payment Taken Successfully. DO NOT CLOSE THE WINDOW', show: true});
          this.showAlert = true;
          this.infoText = 'Payment Taken - You can now save the booking';
        } catch (err) {
          if (err.response) {
            this.setToast({color: 'error', text: err.response.data.error, show: true})
          } else {
            this.setToast({color: 'error', text: err.message, show: true})
          }
        } finally {
          this.addingCard = false;
          this.$refs.stripeCard.clearableCallback();
        }
      }
      this.addingCard = false;

    },
  }
}
</script>
